module.exports = __webpack_public_path__ + "img/frantic_logo.ba38d3bd.svg";